import axios from 'axios'
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import ToggleSwitch from 'vuejs-toggle-switch';
import PieChart from "./PieChart.js";
import moment from 'moment';
import { Validator } from 'vee-validate';
import CargoAllocationService from './../../services/cargoallocation.service';

export default {
  name: 'dashboard',
  components: {
    VueElementLoading,
    ToggleSwitch,
    PieChart
  },
  props: [],
  data() {
    return {
      totalPickups:0,
      allocatedPickup:0,
      pickupGeneratedNotAllocated:0,
      pendingForPickupAllocationShipment:0,
      pickDonePickup:0,
      cancelledPickup:0,
      pickDoneShipment:0,
      cancelledShipment:0,
      totalShipment:0,
      date: new Date().toISOString().slice(0,10),
      pendingForPickupGenerationShipment:0,
      allocatedShipment:0,
      isLoading:false,
      username:'',
      project:'',
      dateTo:'',
      dateFrom:'',
      myOptions: {
        layout: {
          color: 'black',
          backgroundColor: 'lightgray',
          selectedColor: 'white',
          selectedBackgroundColor: 'green',
          borderColor: '#ffffff',
          fontFamily: 'Helvetica',
          fontWeight: 'normal',
          fontWeightSelected: 'bold',
          squareCorners: true,
          noBorder: false
        },
        size: {
            fontSize: 0.80,
            height: 2.2,
            padding: 0.4,
            width: 30
          },
          items: {
            delay: .4,
            preSelected: "Today",
            disabled: false,
            labels: [
              {name: "Today", color: 'white', backgroundColor: '#0000ff'},
              {name: 'Weekly', color: 'white', backgroundColor: '#0000ff'},
              {name: 'Monthly', color: 'white', backgroundColor: '#0000ff'},
              {name: 'Quarterly', color: 'white', backgroundColor: '#0000ff'},
              {name: 'Half Yearly', color: 'white', backgroundColor: '#0000ff'},
              {name: 'Yearly', color: 'white', backgroundColor: '#0000ff'}
            ]
          }
        },
        isPieChartDataAvailable: false,
        isPieLoading: false,
        chartOptions: {
          hoverBorderWidth: 20
        },
        chartData: {
          hoverBackgroundColor: "red",
          hoverBorderWidth: 10,
          labels: ['Pickup Not Generated','Allocation Pending','Allocated to SR','Pick Done','Cancelled'],
          datasets: [
            {
              label: "Data One",
              backgroundColor: ["#ffa83d", "#ffc107", "#20a8d8", "#06d149", "#fc1616"],
              data: []
            }
          ]
        }
    }
  },
  computed: {

  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.localuserid = parseInt(userdetail.userid);
    this.createdby = userdetail.username;
    this.username = userdetail.username;
    this.project = userdetail.project;
    this.hubID = userdetail.hubID;
    this.hubName = window.localStorage.getItem('currentHubName');
    this.updateMap();
    this.traceIP();
  },
  methods: {
        updateMap(daysval){
          switch(daysval) {
            case "Today":
              this.dateTo = moment().format('YYYY-MM-DD');
              this.dateFrom = moment().format('YYYY-MM-DD');
              break;
            case "Weekly":
              this.dateTo = moment().format('YYYY-MM-DD');
              this.dateFrom = moment().subtract(7,'d').format('YYYY-MM-DD');
              break;
            case "Monthly":
              this.dateTo = moment().format('YYYY-MM-DD');
              this.dateFrom = moment().subtract(1,'M').format('YYYY-MM-DD');
              break;
            case "Quarterly":
              this.dateTo = moment().format('YYYY-MM-DD');
              this.dateFrom = moment().subtract(3,'M').format('YYYY-MM-DD');
              break;
            case "Half Yearly":
              this.dateTo = moment().format('YYYY-MM-DD');
              this.dateFrom = moment().subtract(6,'M').format('YYYY-MM-DD');
              break;
            case "Yearly":
              this.dateTo = moment().format('YYYY-MM-DD');
              this.dateFrom = moment().subtract(1,'Y').format('YYYY-MM-DD');
              break;
            default:
              this.dateTo = moment().format('YYYY-MM-DD');
              this.dateFrom = moment().format('YYYY-MM-DD');
          }
          this.getShipmentCountDetails();
        },
        showData(status){
          if(status=='pending'){
            this.$router.push(`/manualpickupgeneration?dateFrom=`+this.dateFrom+'&dateTo='+this.dateTo);
          }else if(status=='pickupgenerated'){
            this.$router.push(`/pickupallocation`);
          }else if(status=='pickupassign'){
            this.$router.push(`/pickupuserwisereport?dateFrom=`+this.dateFrom+'&dateTo='+this.dateTo+'&status='+status);
          }else if(status=='pickdone'){
            this.$router.push(`/pickupuserwisereport?dateFrom=`+this.dateFrom+'&dateTo='+this.dateTo+'&status='+status);
          }else if(status=='cancelled'){
            this.$router.push(`/pickupuserwisereport?dateFrom=`+this.dateFrom+'&dateTo='+this.dateTo+'&status='+status);
          }
        },
        async getPickupCountDetails(){
          try {
            let InputPayload = {
              hubid: this.hubID[0],
              date: this.date
            };
            this.isLoading = true;
            let response = await CargoAllocationService.getPickupCountDetails(InputPayload);
            this.isLoading = false;
            if(response.data.code == 200){
              let tmpData = [];
              let totpickups=0;
              response.data.data.forEach(result=>{
                tmpData[response.status] = response.cnt;
                totpickups += parseInt(response.cnt);
              });
              this.totalPickups = totpickups;
              this.allocatedPickup = (tmpData['pickupassign']!=undefined?tmpData['pickupassign']:0);
              this.pickupGeneratedNotAllocated = (tmpData['pickupgenerated']!=undefined?tmpData['pickupgenerated']:0);
              this.pickDonePickup = (tmpData['pickdone']!=undefined?tmpData['pickdone']:0);
              this.cancelledPickup = (tmpData['cancelled']!=undefined?tmpData['cancelled']:0);
            }else {
              this.$alert("Unable to fetch record.","Pickup Count Details","error");
            }
          } catch(err){
            console.log(err);
            this.isLoading = false;
          }
        },
        async getShipmentCountDetails(){
          try {
            this.isLoading = true;
            this.totalShipment = '';
            this.isPieChartDataAvailable = false;
            this.chartData.datasets[0].data =[];

            let InputPayload = {
              hubid: this.hubID[0],
              dateTo: this.dateTo,
              dateFrom: this.dateFrom
            };

            let response = await CargoAllocationService.getShipmentCountDetails(InputPayload);
            this.isLoading = false;
            if(response.data.code == 200){
              let tmpData = [];
              let totshipments=0;
              let resultdata = response.data.data;
              resultdata.forEach(item=>{
                tmpData[item.status] = item.cnt;
                totshipments += parseInt(item.cnt);
              });

              this.totalShipment = totshipments;
              this.pendingForPickupGenerationShipment = (tmpData['pending']!=undefined?tmpData['pending']:0);
              this.pendingForPickupAllocationShipment = (tmpData['pickupgenerated']!=undefined?tmpData['pickupgenerated']:0);
              this.allocatedShipment = (tmpData['pickupassign']!=undefined?tmpData['pickupassign']:0);
              this.pickDoneShipment = (tmpData['pickdone']!=undefined?tmpData['pickdone']:0);
              this.cancelledShipment = (tmpData['cancelled']!=undefined?tmpData['cancelled']:0);

              if(this.totalShipment>0){
                this.isPieChartDataAvailable = true;
                this.chartData.datasets[0].data.push(this.pendingForPickupGenerationShipment);
                this.chartData.datasets[0].data.push(this.pendingForPickupAllocationShipment);
                this.chartData.datasets[0].data.push(this.allocatedShipment);
                this.chartData.datasets[0].data.push(this.pickDoneShipment);
                this.chartData.datasets[0].data.push(this.cancelledShipment);
              }
            }else {
              this.$alert("Unable to fetch record.","Pickup Count Details","error");
            }
          } catch(err){
            console.log(err);
            this.isLoading = false;
          }
      },
      traceIP(){
        try {
          let InputPayload = {
            "projectname": this.project,
            "type": "web",
            "userid": this.localuserid,
            "username":this.username,
            "routeurl": "/dashborad",
            "meta" : {
              "event" : "dashbord"
            }
          };
          let response = CargoAllocationService.traceIP(InputPayload);
          if(response.data.code == 100){
            return true;
          }else {
            return true;
          }
        } catch(err){
          console.log(err);
        }
      }
  }
}



// WEBPACK FOOTER //
// ./src/modules/cargoallocation/views/dashboard/dashboard.component.js